import { supabase } from '../lib/supabase';

export async function checkDriverTable() {
  console.log("Checking driver_full_profile table...");
  
  try {
    // First, check if the table exists by getting its structure
    console.log("Checking table structure...");
    const { data: tableInfo, error: tableError } = await supabase
      .from('driver_full_profile')
      .select('race_number')
      .limit(1);
    
    if (tableError) {
      console.error("Error checking table structure:", tableError);
      return { error: tableError, exists: false };
    }
    
    console.log("Table structure check result:", tableInfo);
    
    // Get a sample of records to check table data
    console.log("Fetching sample records...");
    const { data: allDrivers, error: driversError } = await supabase
      .from('driver_full_profile')
      .select('race_number, first_name, last_name, search_name')
      .limit(10);
    
    console.log("Sample records:", allDrivers);
    if (driversError) {
      console.error("Error fetching drivers:", driversError);
      return { error: driversError, exists: true, hasData: false };
    }
    
    // Check if search_name column exists and has data
    const hasSearchNameColumn = allDrivers && allDrivers.length > 0 && 'search_name' in allDrivers[0];
    console.log("Has search_name column:", hasSearchNameColumn);
    
    // Try a simple search using search_name
    console.log("Testing search functionality...");
    const testSearchTerm = 'test';
    console.log(`Making test query: .from('driver_full_profile').select('race_number').ilike('search_name', '%${testSearchTerm}%').limit(1)`);
    
    const { data: searchResult, error: searchError } = await supabase
      .from('driver_full_profile')
      .select('race_number')
      .ilike('search_name', `%${testSearchTerm}%`)
      .limit(1);
    
    console.log("Test search result:", searchResult);
    if (searchError) {
      console.error("Search test error:", searchError);
      return { 
        error: searchError, 
        exists: true, 
        hasData: allDrivers && allDrivers.length > 0,
        hasSearchNameColumn
      };
    }
    
    return { 
      exists: true,
      hasData: allDrivers && allDrivers.length > 0,
      hasSearchNameColumn,
      searchWorks: !searchError,
      sampleData: allDrivers
    };
  } catch (error) {
    console.error("Error in checkDriverTable:", error);
    return { error };
  }
}